import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromCountrySpec from './+state/country-spec.reducer'
import { CountrySpecEffects } from './+state/country-spec.effects'
import { CountrySpecFacade } from './+state/country-spec.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCountrySpec.COUNTRY_SPEC_FEATURE_KEY, fromCountrySpec.countrySpecReducer),
    EffectsModule.forFeature([CountrySpecEffects]),
  ],
  providers: [CountrySpecFacade],
})
export class GbDashboardSharedDataAccessCountrySpecModule {}
